/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/common/app';
import { slug } from '../';
import Component from 'flarum/common/Component';
import iconHelper from 'flarum/common/helpers/icon';
import Link from 'flarum/common/components/Link';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.lib.achievement_level`;

export default class AchievementLevel extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	callFunctionOrDefault(obj, funcName, defaultValue) {
		if (typeof obj[funcName] === 'function') {
			return obj[funcName]() ? obj[funcName]() : defaultValue;
		}
	}

	propertyDefaults = {
		backgroundColor: 'var(--body-bg-shaded)',
		iconColor: 'inherit',
		levelBgColor: 'var(--text-color)',
		levelTextColor: 'var(--body-bg)',
		image: null,
		icon: null,
		level: null,
		name: null,
		description: null,
	};

	view() {
		const { achievementLevel, more, link, actions, showDesc } = this.attrs;

		if (!achievementLevel) {
			return null; // or return a placeholder/fallback component
		}

		const props = Object.keys(this.propertyDefaults).reduce((acc, prop) => {
			acc[prop] = this.callFunctionOrDefault(achievementLevel, prop, this.propertyDefaults[prop]);
			return acc;
		}, {});

		const { backgroundColor, iconColor, levelBgColor, levelTextColor, image, icon, level, name, description } = props;

		return (
			<div
				className={`AchievementLevel ${Number.isInteger(more) ? 'AchievementLevel--more' : ''}`}
				style={{
					'--achievement-bg': backgroundColor,
					'--achievement-icon-color': iconColor,
					'--achievement-level-bg-color': levelBgColor,
					'--achievement-level-text-color': levelTextColor,
				}}
			>
				<div className="AchievementLevel-shape">
					<div className="AchievementLevel-iconContainer">
						{image && <div className="AchievementLevel-image" style={{ '--achievement-image': `url("${image}")` }}></div>}
						{!image && icon && iconHelper(icon)}
						{Number.isInteger(more) && link && (
							<Link className="AchievementLevel-more" href={link}>
								{more > 0 ? t(`${prfx}.more`, { count: more }) : null}
							</Link>
						)}
					</div>
					{level && <div className="AchievementLevel-level">{level}</div>}
				</div>

				<div className="AchievementLevel-infos">
					{name && <div className="AchievementLevel-name">{name}</div>}
					{showDesc && description && <div className="AchievementLevel-description">{description}</div>}
				</div>

				{actions && <div className="AchievementLevel-actions">{actions}</div>}
			</div>
		);
	}
}
